import React, { useEffect, useState } from "react";

// reactstrap components
import {
	Card,
	CardHeader,
	CardBody,
	Table,
	Row,
	FormGroup,
	Input,
	Label,
	Collapse,
	Col,
	Button
} from "reactstrap";
import { Link } from "react-router-dom";
import * as moment from "moment";
import { STATUS_LIST, DATE_FORMATS, MESSAGES, PAGE_LIMIT } from '../../configs/constant'

import { DEPARTMENT } from '../../configs/urls'
import { getApi, deleteApi } from '../../services/api'

import Loader from '../../components/Loader'
import Toaster from "../../components/Toaster";

import './styles.css'
import { FaEdit } from 'react-icons/fa'
import { AiFillDelete } from 'react-icons/ai'

const DepartmentList = () => {

	const [isRequesting, setIsRequesting] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [canShowLoadMore, setCanShowLoadMore] = useState(false)
	const [isFilterOpen, setIsFilterOpen] = useState(false)
	const [filterParams, setFilterParams] = useState({
		page: 0,
		size: PAGE_LIMIT
	})
	const [departments, setDepartments] = useState([])

	useEffect(() => {
		fetchDepartment(false, true)
	}, []);

	const fetchDepartment = (isLoadMore, isInitialLoad) => {
		isInitialLoad ? setIsRequesting(true) : setIsLoading(true);

		const params = JSON.parse(JSON.stringify(filterParams))

		for (const key in params) {
			if ((!params[key] && params[key] != 0) || params[key] == -1) {
				delete params[key]
			}
		}

		getApi(DEPARTMENT, params)
			.then((res) => {
				const departmentData = isLoadMore ? [...departments, ...res.data] : res.data;
				setDepartments(departmentData);
				setCanShowLoadMore(departmentData.length < res.meta.total)
			}, (err) => {
				console.log(err);
			}).finally(() => {
				isInitialLoad ? setIsRequesting(false) : setIsLoading(false);
			})
	}

	const deleteDepartment = (department_id) => {
		var proceed = window.confirm("Are you sure you want to delete Department?");
		if (proceed) {
			deleteApi(`${DEPARTMENT}/${department_id}`)
				.then((res) => {
					let list = departments
					list = list.filter(item => item.id != department_id)
					setDepartments(list)
					Toaster.showSuccess(res.message || 'Department deleted successfully.')
				}, (err) => {
					Toaster.showError(err.message)
				})
		}
	}

	const handleChange = (event) => {
		event.persist();
		setFilterParams(values => ({ ...values, [event.target.name]: event.target.value }));
	};

	const resetFilter = () => {
		setFilterParams({
			status: -1,
			name: '',
			page: 0,
			size: PAGE_LIMIT
		})

		fetchDepartment();
	}

	
	const loadMoreDepartments = () => {
		const params = filterParams;
		params.page++;

		setFilterParams(params)

		fetchDepartment(true);
	}

	const searchDepartments = () => {
		const params = filterParams;
		params.page = 0;

		setFilterParams(params)

		fetchDepartment();
	}

	const renderDepartments = () => (
		<div className="content">
			<Row>
				<Col md="12">
					<Card>
						<CardHeader className="header-section">
							<div>
								<Button color="primary" onClick={() => setIsFilterOpen(!isFilterOpen)}>Filter</Button>
							</div>
							<Link to="departments/operations">
								<Button color="primary" className="text-right">Add New Department</Button>
							</Link>
						</CardHeader>

						<Collapse isOpen={isFilterOpen} className="border-top">
							<Card>
								<CardBody>
									<Row>
										<Col className="pr-1" md="4">
											<FormGroup>
												<label>Department</label>
												<Input
													type="text"
													name="name"
													placeholder="Department Name"
													value={filterParams.name || ""}
													onChange={handleChange}
												/>
											</FormGroup>
										</Col>

										<Col className="pr-1" md="4">
											<FormGroup>
												<Label for="status">Status</Label>
												<Input
													type="select"
													name="status"
													value={filterParams.status}
													onChange={handleChange}
												>
													{
														STATUS_LIST.map(status => (
															<option key={status.id} value={status.id}>{status.title}</option>
														))
													}
												</Input>
											</FormGroup>
										</Col>

										<Col className="pr-1" md="4">
											<div className="update ml-auto mt-3 mr-auto">
												<Button className="btn-round" onClick={() => searchDepartments()} color="primary">
													Search
												</Button>
												<Button className="btn-round ml-2" onClick={() => resetFilter()} color="primary">
													Reset
												</Button>
											</div>
										</Col>
									</Row>
								</CardBody>
							</Card>
						</Collapse>

						<hr />

						<CardBody>
							<Table>
								<thead className="text-primary">
									<tr>
										<th>ID</th>
										<th>Department Name</th>
										<th>Status</th>
										<th>Last Update</th>
										<th className="text-right">Actions</th>
									</tr>
								</thead>
								<tbody>
									{
										departments.map((department, idx) => (
											<tr key={idx}>
												<td>{department.id}</td>
												<td>{department.name || '--'}</td>
												<td>{department.status == 1 ? 'Enabled' : 'Disabled'}</td>
												<td>{department.updated_at ? moment(department.updated_at).format(DATE_FORMATS.DATE_TIME_FORMAT) : '--'}</td>
												<td className="text-right action-icons">
													<Link to={`departments/operations/${department.id}`}>
														<FaEdit />
													</Link>
												</td>
											</tr>
										))
									}
								</tbody>
							</Table>
							{
								departments.length == 0 &&
								<span className="no-record-found">{MESSAGES.NO_RECORD_FOUND}</span>
							}
						</CardBody>
					</Card>
				</Col>
			</Row>
			{
				canShowLoadMore && 
				<Row>
					<Col className="load-more-col">
						<Button className="action-btn" onClick={() => loadMoreDepartments()} color="primary">Load more</Button>
					</Col>
				</Row>
			}
			<Loader isLoading={isLoading} />
		</div>
	)

	return (
		<>
			{
				isRequesting
					? <div className="content"><Loader isLoading={isRequesting} /></div>
					: renderDepartments()
			}
		</>
	);
}

export default DepartmentList;
